module.exports = __webpack_public_path__ + "img/Apple Watch Series 10.54c0bc63.jpg";